import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-report-success-dialog',
  templateUrl: './report-success-dialog.component.html',
  styleUrls: ['./report-success-dialog.component.scss']
})
export class ReportSuccessDialogComponent implements OnInit {

  constructor(
    public matDialogRef: MatDialogRef<ReportSuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit(): void {
  }

}
